export default __webpack_public_path__ + "static/media/dhl-inabit.cd2dfa1b.svg";